/**
 * 对账计费管理
 * 创建时间：2017-12-08
 * 创建人：baixx
 */
<template>
<div class="wrapper-content fadeInRight animated tabBox" id="billing-mangen-ment">
    <div class="ibox-content" v-loading="loadingstatus" element-loading-text="加载中">
		<!--表单查询开始-->
		<div class="form-horizontal pt10px">
			<div class="form-group pt5px mr40px" style="margin-left:55px;">
				<label style="font-size: 15px;">计费控制</label>
			</div>
			<div class="form-group" style="margin-left:105px;">
				<div class="col-sm-12 text-left">
					<button :disabled="chargeRecord==1" type="button" class="btn btn-primary" @click="controlCharging(1)">开始计费</button>&nbsp;&nbsp;
					<button :disabled="chargeRecord==2||chargeRecord==3" type="button" class="btn btn-primary" @click="controlCharging(2)">暂停计费</button>&nbsp;&nbsp;
					<button :disabled="chargeRecord==3" type="button" class="btn btn-primary" @click="controlCharging(3)">停止计费</button>
				</div>
			</div>
			<div class="form-group mt20px">
				<div class="col-sm-3">
					<div class="form-group pt5px mr40px" style="margin-left:55px;">
						<label style="font-size: 15px;">计费规则</label>
					</div>
				</div>
				<!--<div class="col-sm-2">
					<div class="pl50px mt5px">
						<checkbox v-model="includingCheck">是否包含截止累计数</checkbox>
					</div>
				</div> -->
				<span class="col-sm-3 control-label">救援单数量超出上限值时，平台费用单价</span>
				<div class="col-sm-1">
					<input type="text" :readonly="chargeRecord==1" class="form-control" v-model="maxPrice" maxlength="20" onkeyup="if(isNaN(value))execCommand('undo')" onafterpaste="if(isNaN(value))execCommand('undo')">
					 <p v-show="!validDates" class="cus_message form-group__message">小数点保留最多两位</p>
				</div>
				<!--<span class="col-sm-1 control-label gray t_left">元/公里计价</span>-->
			</div>
			<div class="form-group">
				<div style="padding-right: 75px;" class="col-sm-12 text-right">
					<button type="button" class="btn btn-primary" :disabled="chargeRecord==1" @click="addMileagePrice">新增</button>
				</div>
			</div>
		</div>
		<!--表格开始-->
		<table style="width:92%;" align="center" class="table mt20px table-striped table-bordered">
		<!--<table style="width:92%;" align="center" class="table mt20px table-striped table-bordered">-->
			<thead>
				<tr>
					<th style="width:2%"></th>
					<th style="width:10%" class="red">*救援单数量起始值，大于</th>
					<th style="width:15%" class="red">*救援单数量上限值，小于等于</th>
					<th style="width:10%" class="red">*平台费用单价</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(fileInfo,index) in billingRuleData" v-bind:key="index">
					<td class="text-center">
						<a v-show="index!=0" class="glyphicon glyphicon-trash" @click="deleteMessage(index)"></a>
					</td>
					<td><input :readonly="chargeRecord==1" type="text" class="form-control" v-model="fileInfo.startNumber"></td>
					<td><input :readonly="chargeRecord==1" type="text" class="form-control" v-model="fileInfo.endNumber"></td>
					<td><input :readonly="chargeRecord==1" type="text" class="form-control" v-model="fileInfo.platformPrice" onKeyPress="if((event.keyCode<48 || event.keyCode>57) && event.keyCode!=46 || /\.\d\d$/.test(value))event.returnValue=false"></td>
				</tr>
			</tbody>
		</table>
		</br>
		<div class="form-group">
			<div class="col-sm-12 text-center">
				<button type="button" class="btn btn-primary" :disabled="!validDates||chargeRecord==1" @click="saveRescueOrder">保存</button>
			</div>
		</div>
		</br>
		<!--弹出框子组件-->
		<tab-modal ref="modalMsg" size="small" :scroll='scrollTop' title="提示" v-on:cancel="closeModalMsg">
			{{messageStr}}
			<div slot="footer">
		        <button @click="closeModalMsg" class="btn btn-primary">确定</button>
		    </div>
		</tab-modal>
		<!--计费控制弹出框子组件-->
		<tab-modal ref="modalMsgBill" size="small" :scroll='scrollTop' title="提示" v-on:cancel="closeModalMsgbill">
			{{messageStr}}
			<div slot="footer">
				 <button @click="closeModalMsgbill" class="btn btn-primary">取消</button>
		        <button @click="confirmModalMsgbill" class="btn btn-primary">确定</button>
		    </div>
		</tab-modal>
	</div>
</div>
</template>
<script>
	import Pagination from 'components/common/Pagination'
	import { OPERATE_EXCEPTION } from 'static/message'
	import TabModal from 'components/common/TabModal'
	import classlist from 'util/classlist'
	import { maxLength } from 'vuelidate/lib/validators'
	export default {
		name: "PageBillingMangeMent",
		components: {
			Pagination,
			TabModal,
		},
		data() {
			return {
				loadingstatus:false,
				maxPrice:'',                                             //超出的价格
				billingRuleData:[],                                      //获取计费规则信息
				upDataArr:[],
				messageStr: "",					                         // 弹出框内容
				scrollTop: '',
				chargeRecord:"",                                         //计费记录状态
				billSelect:"",                                           //计费方式选择
			};
		},
		computed: {
			validDates: function(){
				//判断是否包含小数点
				var reg = /.*\..*/;
				if(reg.test(this.maxPrice) && this.maxPrice.toString().split(".")[1].length>2){
					return false;
				} else {
					return true;
				}
			}
		},
		beforeMount() {
			//获得计费控制状态
			this.getBillingStatus();
			//获取计费规则
			this.getBillingRule();
		},
		methods: {
			//计费控制弹出提示
			controlCharging(msg){
				this.billSelect = msg;
				if(msg==1){
					this.openModalMsgBill("开始计费后，每次产生救援费用的救援单将计算平台费用。");
				}
				if(msg==2){
					this.openModalMsgBill("暂停计费后，期间的救援任务不计算平台费用，直至重新开始计费。");
				}
				if(msg==3){
					this.openModalMsgBill("停止计费后，重新开始计费前发生的救援单不产生平台费用；且该计费周期结束，对账报表下方的计费周期统计内容不再更新；重新开始计费后，计费周期自动统计内容将进行重置。");
				}
			},
			//计费控制确定
			confirmModalMsgbill(){
				this.closeModalMsgbill();
				this.loadingstatus = true;
				this.$http.post(process.env.API_INSURANCE_ROOT  + '/rescue-api/cost/change/'+this.billSelect)
					.then( res => {
						if(res.body.success){
							this.getBillingStatus();
						}
					}, res => {
						this.openModalMsg(res.body.message);
						this.loadingstatus = false;
					}).catch( res => {
						this.openModalMsg(OPERATE_EXCEPTION);
						this.loadingstatus = false;
				})
			},
			//新增计算价格
			addMileagePrice(){
				if(this.billingRuleData.length<7){
					let instr = {};
		 			instr.startNumber = null
		 			instr.endNumber = null
		 			instr.platformPrice = null
					this.billingRuleData.push(instr);
				}else{
					this.openModalMsg("救援规则最多可建5个");
				}
			},
			//获得计费控制状态
			getBillingStatus(){
				this.loadingstatus = true;
				this.$http.get(process.env.API_INSURANCE_ROOT  + '/rescue-api/cost/get/status')
					.then( res => {
						if(res.body.success){
							this.chargeRecord = res.body.data
						}
						this.loadingstatus = false;
					}, res => {
						this.openModalMsg(res.body.message);
						this.loadingstatus = false;
					}).catch( res => {
						this.openModalMsg(OPERATE_EXCEPTION);
						this.loadingstatus = false;
				})
			},
			//获取计费规则
			getBillingRule(){
				this.loadingstatus = true;
				this.$http.get(process.env.API_INSURANCE_ROOT  + '/rescue-api/cost/list/rules')
					.then( res => {
						if(res.body.success){
							this.maxPrice = res.body.data[0].maxPrice/100
							//this.billingRuleData = res.body.data;
							for(var i = 0; i < res.body.data.length; i++) {
								let instr = {};
								instr.startNumber = res.body.data[i].startNumber
					 			instr.endNumber = res.body.data[i].endNumber
					 			instr.platformPrice =res.body.data[i].platformPrice/100;
								this.billingRuleData.push(instr);
							}
						}
						this.loadingstatus = false;
					}, res => {
						this.openModalMsg(res.body.message);
						this.loadingstatus = false;
					}).catch( res => {
						this.openModalMsg(OPERATE_EXCEPTION);
						this.loadingstatus = false;
				})
			},
			//规则数据排序
			 compare (prop) {
			    return function (obj1, obj2) {
			        var val1 = obj1[prop];
			        var val2 = obj2[prop];
			        if (!isNaN(Number(val1)) && !isNaN(Number(val2))) {
			            val1 = Number(val1);
			            val2 = Number(val2);
			        }
			        if (val1 < val2) {
			            return -1;
			        } else if (val1 > val2) {
			            return 1;
			        } else {
			            return 0;
			        }
			    }
			},
			//保存
			saveRescueOrder(){
				let arr = [];
				let upDataArr= [];
				arr = Object.assign([],this.billingRuleData);
				arr.sort(this.compare("startNumber"))
				for(var i = 0; i < arr.length; i++) {
					if(arr[i].startNumber =="" && arr[i].startNumber!=0) {
						this.openModalMsg("救援单数量起始值不能为空");
							return;
					}
					if(arr[i].endNumber =="") {
						this.openModalMsg("救援单数量上限值不能为空");
							return;
					}
					if(parseInt(arr[i].startNumber) >= parseInt(arr[i].endNumber)) {
						this.openModalMsg("起始累计数应小于截止累计数");
							return;
					}
					if( i<=arr.length-2 ){
						if(arr[i].endNumber!=arr[i+1].startNumber) {
							this.openModalMsg("请输入连续累计数");
							return;
						}
          }
          if(arr[i].platformPrice=="" ||arr[i].platformPrice==0){
             	this.openModalMsg("平台费用单价不能为空");
							return;
          }
					let instr = {};
					instr.startNumber = arr[i].startNumber
		 			instr.endNumber = arr[i].endNumber
		 			instr.platformPrice =parseInt(parseFloat(arr[i].platformPrice)*100);
					upDataArr.push(instr);
				}
			    const para = {
			    	including:1,
			    	maxPrice:this.maxPrice*100,
					ruleList:upDataArr,
				}
			    this.loadingstatus = true;
				this.$http.post(process.env.API_INSURANCE_ROOT + '/rescue-api/cost/update/rules',para)
					.then(res => {
						if(res.data.success) {
							this.openModalMsg("保存成功");
						} else {
							this.openModalMsg(res.data.message);
						}
						this.loadingstatus = false;
					}, res => {
						this.loadingstatus = false;
						this.openModalMsg(res.data.message);
					}).catch(res => {
						this.loadingstatus = false;
						this.openModalMsg(OPERATE_EXCEPTION);
				})
			},
			// 拖车里程价格维护删除
			deleteMessage(index){
				this.billingRuleData.splice(index, 1);
			},
			// 消息弹出框相关
			openModal(ref) {
            	this.$refs[ref].open();
            	classlist.toggleScroll('close','#billing-mangen-ment',this);
        	},
        	closeModal(ref){
        		this.$refs[ref].close();
        		classlist.toggleScroll('open','#billing-mangen-ment',this);
        	},
        	closeModalMsg(){
        		this.closeModal("modalMsg");
        	},
        	openModalMsg(message){
        		this.messageStr = message;
        		this.openModal("modalMsg")
        	},

        	//计费控制弹窗
        	openModalMsgBill(message){
        		this.messageStr = message;
        		this.openModal("modalMsgBill")
        	},
        	closeModalMsgbill(){
        		this.closeModal("modalMsgBill");
        	}
		}
	}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// PageBillingMangeMent.vue?189aae1c